import React from 'react';
import {
    LoginContainer,
    LoginContent,
    Clear,
    Form,
    Title,
    Submit,
    Logotipo,
    Center,
    Division,
    Message,
    ButtonSoft,
    Buttons,
    FormDiv,
    Mobile,
    Hr,
    Flex
} from './styled';
import useForm from "../../hooks/useForm";
import Input from "../../components/Form/Input";
import {Link, Navigate} from "react-router-dom";
import Logo from '../../assets/svg/logo.svg';
import {UserContext} from '../../UserContext';
import Button from '../../components/Button';
import {Snackbar} from '@material-ui/core';
import MuiAlert, {AlertProps} from '@material-ui/lab/Alert';

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Login: React.FC = () => {
    document.title = "Login - Sultan Veste a Casa";

    const email = useForm('email');
    const password = useForm('password');

    const {userLogin, loading, error, login} = React.useContext(UserContext);

    React.useEffect(() => {
        if (error !== "") handleClick();
    }, [error]);

    function doLogin(e: React.FormEvent): void {
        e.preventDefault();

        if (email.validate() && password.validate()) {
            userLogin(email.value, password.value);
        }
    }

    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };
    
    if (login === true) return <Navigate to={`${process.env.PUBLIC_URL}/usuario/inicio`}/>;

    return (    
        <LoginContainer>
            <LoginContent>
                <Division>
                    <Flex>
                        <FormDiv>
                            <Center>
                                <a href="https://sultan.com.br" title="Sultan Veste a Casa">
                                    <Logotipo title="Logo da Sultan Veste a Casa" alt="Logo da Sultan Veste a Casa" src={Logo}/>
                                </a>
                            </Center>
                            <Mobile>
                                <h3>Ainda não tem uma conta ?</h3>
                                <p>Na Área Restrita você tem acesso a diversas funcionalidades, dependêndo do seu nível
                                    de acesso:</p>
                                <Buttons>
                                    <Link to={`${process.env.PUBLIC_URL}/cadastro`} title="Cadastre-se">
                                        <ButtonSoft>Cadastre-se</ButtonSoft>
                                    </Link>
                                </Buttons>
                                <Hr/>
                            </Mobile>
                            <Form onSubmit={doLogin}>                                
                                <Title>Entre em sua Conta!</Title>
                                <Input label="Seu E-mail:" autoComplete="off" id="email" type="text" {...email}/>
                                <Input label="Sua Senha:" id="password" type="password" {...password}/>
                                <Submit>
                                    <Link to={`${process.env.PUBLIC_URL}/esqueci-minha-senha`}>Não se lembra da senha ?</Link>
                                    {loading ? <Button type="submit" disabled>Carregando...</Button> :
                                        <Button type="submit">Entrar</Button>}
                                </Submit>
                            </Form>
                            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
                                <Alert onClose={handleClose} severity="error">
                                    {error && error}
                                </Alert>
                            </Snackbar>                            
                        </FormDiv>
                    </Flex>
                    <Message>
                        <a href="https://sultan.com.br" title="Sultan Veste a Casa">
                            <Logotipo title="Logo da Sultan Veste a Casa" alt="Logo da Sultan Veste a Casa" src={Logo}/>
                        </a>
                        <h1>Bem-Vindo(a) a Área Restrita!</h1>
                        <h3>Ainda não tem uma conta ?</h3>
                        <p>Na Área Restrita você tem acesso a diversas funcionalidades, dependêndo do seu nível de
                            acesso:</p>
                        <Buttons>
                            <Link to={`${process.env.PUBLIC_URL}/cadastro`} title="Cadastre-se">
                                <ButtonSoft>Cadastre-se</ButtonSoft>
                            </Link>
                        </Buttons>
                    </Message>
                </Division>
                <Clear/>
            </LoginContent>
        </LoginContainer>
    );
};

export default Login;